// @noflow
export const radFromCoords = (x, y, width, height) => {
    const center = {
        x: width / 2,
        y: height / 2
    };

    const deltaX = x - center.x;
    const deltaY = y - center.y;

    const result = Math.atan2(deltaY, deltaX);

    return result < 0 ? Math.abs(result) : Math.PI * 2 - result;
};

export const coordsFromRadians = (radians, radius, width, height) => {
    const center = {
        x: width / 2,
        y: height / 2
    };

    return {
        x: center.x + radius * Math.cos(-radians),
        y: center.y + radius * Math.sin(-radians)
    };
};



// WEBPACK FOOTER //
// ./src/core/utils/math/trig.js